import { render, staticRenderFns } from "./ClientStatement.vue?vue&type=template&id=aa93f86e&scoped=true&"
import script from "./ClientStatement.vue?vue&type=script&lang=js&"
export * from "./ClientStatement.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatement.vue?vue&type=style&index=0&id=aa93f86e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa93f86e",
  null
  
)

export default component.exports